import { Store } from '../../../app/services/api/generated';

export const ALL_STORES_TOKEN = '__ALL_STORES__';

export type StoreOption = {
  storeName: string;
  storeNumber: string;
  isAll?: boolean;
  _numKey?: number;
};

export type StoreSelection =
  | { mode: 'all' }
  | { mode: 'specific'; storeNumbers: string[] };

export interface MultiStorePickerProps {
  /** Array of stores from user context or API */
  stores: Store[];
  /** Current selection state */
  value: StoreSelection;
  /** Callback when selection changes */
  onChange: (selection: StoreSelection) => void;
  /** Label for "All Stores" option - pass translated string */
  allStoresLabel: string;
  /** Label for the input field */
  label?: string;
  /** Placeholder text for search */
  placeholder?: string;
  /** Whether the picker is disabled */
  disabled?: boolean;
  /** Size of the component */
  size?: 'small' | 'medium';
}
